import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { Flex, BREAKPOINTS } from '@/ui';
import { useQuery } from '@tanstack/react-query';
import { kycApi } from '@/api/kyc';
import { useDispatch, useSelector } from 'react-redux';
import { investorActions } from '@/store/investor';
import styled from 'styled-components';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

export const InvestorProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isVeriffModalOpen, setIsVeriffModalOpen] = useState(false);
  const [isUserVerifiedSet, setIsUserVerifiedSet] = useState(false);
  const [isVeriffModalOnceOpened, setIsVeriffModalOnceOpened] = useState(false);
  const [isVeriffContinueButtonDisabled, setIsVeriffContinueButtonDisabled] = useState(false);
  const investor = useSelector((state) => state.investor);
  const pathname = useSelector((state) => state.pathname);
  const { state } = useLocation();
  const [menuVisible, setMenuVisible] = useState(false);
  const { data: sumSubStatusRes } = useQuery({
    queryKey: ['getSumSubStatus'],
    queryFn: kycApi.getSumSubStatus
  });

  useEffect(() => {
    if (sumSubStatusRes && sumSubStatusRes.data) {
      if (sumSubStatusRes.data.myStatus === 'Accepted') {
        dispatch(investorActions.setIsUserVerified(true));
      } else {
        if (investor.isUserVerified) dispatch(investorActions.setIsUserVerified(false));
      }
      setIsUserVerifiedSet(true);
    }
  }, [sumSubStatusRes, investor]);

  useEffect(() => {
    if (isUserVerifiedSet) {
      if (!investor.isUserVerified && !investor.isAccessibleWithoutVerification) {
        if (!state?.hasOwnProperty('verificationSubmitted')) {
          if (!isVeriffModalOnceOpened) setIsVeriffModalOpen(true);
          setIsVeriffModalOnceOpened(true);
        }
      } else {
        if (isVeriffModalOpen) setIsVeriffModalOpen(false);
      }
    }
  }, [investor, isVeriffModalOnceOpened, isVeriffModalOpen, isUserVerifiedSet, state]);

  const onOpenVeriffLink = async () => {
    setIsVeriffContinueButtonDisabled(true);
    navigate('/sumsub-verification', {
      state: { prevPath: pathname }
    });
  };

  useEffect(() => {
    if (menuVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [menuVisible]);

  return (
    <div onClick={() => setMenuVisible(false)}>
      <Outlet />

      <Modal
        open={isVeriffModalOpen}
        centered
        onCancel={() => setIsVeriffModalOpen(false)}
        footer={null}
      >
        <Flex justify={'center'} $marginBottom={14}>
          <ExclamationCircleOutlined style={{ fontSize: 30, color: '#1877F2' }} />
        </Flex>

        <VerificationModalText level={4}>
          {t('To complete your registration you have to pass verification')}
        </VerificationModalText>

        <Flex justify={'flex-end'} $marginTop={10}>
          <Button
            disabled={isVeriffContinueButtonDisabled}
            type='primary'
            onClick={() => onOpenVeriffLink()}
          >
            {t('Continue')}
          </Button>
        </Flex>
      </Modal>
    </div>
  );
};

const VerificationModalText = styled(Typography.Title)`
  @media (max-width: ${BREAKPOINTS.smd}px) {
    font-size: 16px !important;
  }
`;
